<template>
  <div class="linkedin-post-preview-footer">
    <div class="linkedin-post-preview-footer__top">
      <div class="linkedin-post-preview-footer__likes">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/linkedin_group.png`"
          alt="Comments"
          class="linkedin-post-preview-footer__img"
        />
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/three_lines.svg`"
          alt="Comments"
          class="linkedin-post-preview-footer__lines"
        />
      </div>
      <div class="linkedin-post-preview-footer__comments">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/three_lines.svg`"
          alt="Comments"
          class="linkedin-post-preview-footer__lines"
        />
        <span>Comments</span>
      </div>
    </div>
    <div class="linkedin-post-preview-footer__bottom">
      <div class="linkedin-post-preview-footer__action">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/like_linkedin.svg`"
          alt="Like"
          class="linkedin-post-preview-footer__img"
        />
        Like
      </div>
      <div class="linkedin-post-preview-footer__action">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/comment_linkedin.svg`"
          alt="Comment"
          class="linkedin-post-preview-footer__img"
        />
        Comment
      </div>
      <div class="linkedin-post-preview-footer__action">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/share_linkedin.svg`"
          alt="Share"
          class="linkedin-post-preview-footer__img"
        />
        Share
      </div>
      <div class="linkedin-post-preview-footer__action">
        <img
          :src="`/wp-content/themes/snappy-theme/assets/images/builders/telegram.svg`"
          alt="Send"
          class="linkedin-post-preview-footer__img"
        />
        Send
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.linkedin-post-preview-footer {
  padding: 5px 15px 10px;
  color: $color-ironside-grey;
  font-size: 14px;
  &__top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $color-cloud;
    padding-bottom: 5px;
  }
  &__bottom {
    display: flex;
    justify-content: space-around;
    font-weight: 500;
    padding-top: 10px;
  }
  &__likes,
  &__comments,
  &__action {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  &__img {
    height: 20px;
  }
  &__lines {
    height: 15px;
  }
}
</style>
